var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 63,
    viewBox: "0 0 103 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 1.70312C53.1406 -0.40625 49.625 -0.40625 47.5156 1.70312L1.8125 47.1719C-0.296875 49.5156 -0.296875 53.0312 1.8125 55.1406L7.20312 60.5312C9.3125 62.6406 12.8281 62.6406 15.1719 60.5312L51.5 24.4375L87.5938 60.5312C89.9375 62.6406 93.4531 62.6406 95.5625 60.5312L100.953 55.1406C103.062 53.0312 103.062 49.5156 100.953 47.1719L55.25 1.70312Z",
    fill: "#516393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.3efee09b66600b509ebd66c818301d12.svg";
export { ForwardRef as ReactComponent };